<h2 mat-dialog-title *ngIf="dialogType === 'confirmation'">{{ 'commonConfirmDialog.confirmation' | translate }}</h2>
<h2 mat-dialog-title *ngIf="dialogType === 'information'">{{ 'commonConfirmDialog.information' | translate }}</h2>
<div class="container content" fxLayout="column" fxLayoutAlign="center center">
  <p class="messages">
    {{firstMessage}}<br>{{secondMessage}}
  </p>
  <mat-list class="sub-messages-list">
    <mat-list-item class="sub-messages-list-item" *ngFor="let message of subMessages">
      <p class="sub-message">{{message}}</p>
    </mat-list-item>
  </mat-list>
</div>
<div class="container buttons" fxLayout="row" fxLayoutAlign="center center" position="fixed">
  <mat-dialog-actions>
    <div *ngIf="dialogType === 'confirmation'">
      <button *ngIf="displayCancelOption" class="cancel-button" mat-button color="primary" [mat-dialog-close]="false">{{falseBtnText}}</button>
      <button mat-raised-button [color]="rasedButtonColor" [mat-dialog-close]="true">{{trueBtnText}}</button>
    </div>
    <div *ngIf="dialogType === 'information'">
      <button mat-raised-button [color]="rasedButtonColor" [mat-dialog-close]="'yes'">{{yesBtnText}}</button>
    </div>
  </mat-dialog-actions>
</div>
